import React, { useEffect } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Paper from '@mui/material/Paper';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import TableFooter from '@mui/material/TableFooter';
import { useDispatch, useSelector } from 'react-redux';
import { get_stage_list, setStagePage } from '../../../store/stage/stageSlice';
import TablePagination from '@mui/material/TablePagination';
import { STAGE_LIMIT } from '../../../helpers/constants';
import TablePaginationActions from '../TablePaginationActions';

const columns = [
  { id: 'name', label: 'Stage Name' },
  { id: 'sidebar_menu_name', label: 'Sidebar Menu Name' },
  { id: 'stage_logo', label: 'Stage Logo' },
  { id: 'color', label: 'Color' },
  { id: 'is_active', label: 'Status' },
  { id: 'action', label: 'Actions' }
];

function StageTable(props) {
  const { is_loading,
    total_stage_count,
    is_stage_modal_open,
    handleStageUpdateModal,
    activate_deactivate_stage,
  } = props;
  const { stage_list, page } = useSelector((state) => state.stage);
  const dispatch = useDispatch();
  const rowsPerPage = STAGE_LIMIT

  const handleStatusChange = async (row) => {
    let newStatus = row.is_active ? 'dc' : 'ac';
    await activate_deactivate_stage({ stage_id: row.id, updated_data: newStatus });
  }

  const handleModal = async (c_action, stage_id) => {
    await handleStageUpdateModal(!is_stage_modal_open, c_action, stage_id);
  };

  useEffect(() => {
    dispatch(get_stage_list({ page: page + 1, limit: STAGE_LIMIT }));
  }, [page, dispatch]);

  const handlePageChange = (event, newPage) => {
    dispatch(setStagePage(newPage));
  };
  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer
        sx={{
          maxHeight: { xl: 800, md: 440 },
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#ccc",
            borderRadius: "4px",
          },
        }}
      >
        <Table stickyHeader aria-label="sticky table"
          sx={{
            "& .MuiTableCell-stickyHeader": {
              backgroundColor: "#f5f5f5",
              fontWeight: "bold",
              zIndex: 2,
            },
          }}
        >
          <TableHead>
            <TableRow sx={{
              '& .MuiTableCell-root:not(:first-of-type)': {
                textAlign: 'left',
              }
            }}>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  style={{ minWidth: column.minWidth }}
                  sx={{
                    fontWeight: "bold",
                    backgroundColor: "#eeeeee70",
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {
              stage_list.length > 0 ?
                stage_list
                  .map((row, idx) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={idx}>
                        <TableCell align="left">
                          <Stack display='flex' flexDirection='row' alignItems='left'>
                            <Tooltip title={row.name || "-"} arrow>
                              {row.name ? `${row.name}` : '-'}
                            </Tooltip>
                          </Stack>
                        </TableCell>
                        <TableCell align="left">
                          <Stack display='flex' flexDirection='row' alignItems='left'>
                            <Tooltip title={row.sidebar_menu_name || (row.sidebar_menu && row.sidebar_menu.side_name) || "-"} arrow>
                              {row.sidebar_menu_name || (row.sidebar_menu && row.sidebar_menu.side_name) || '-'}
                            </Tooltip>
                          </Stack>
                        </TableCell>
                        <TableCell align="left">
                          {row.stage_logo ? (
                            <Tooltip title={row.stage_logo.split('/').pop() || "-"} arrow>
                              <img src={row.stage_logo}
                                alt="Stage Logo"
                                style={{ maxWidth: '100px', maxHeight: '100px' }}
                              />
                            </Tooltip>
                          ) : (
                            <Tooltip title="No Logo Uploaded" arrow>
                              <span>No Logo</span>
                            </Tooltip>
                          )}
                        </TableCell>

                        <TableCell align="left">
                          <Stack display='flex' flexDirection='row' alignItems='left' justifyContent='left'>
                            <Tooltip title={row.color || "-"} arrow>
                              {row.color ? `${row.color}` : '-'}
                            </Tooltip>
                          </Stack>
                        </TableCell>

                        <TableCell align="left">
                          <Tooltip title={row.is_active ? 'Active' : 'Inactive' || "-"} arrow>
                            {row.is_active ? 'Active' : 'Inactive'}
                          </Tooltip>
                        </TableCell>
                        <TableCell align="left">
                          <Stack direction="row" justifyContent='left' spacing={2}>
                            <Tooltip title="Edit" arrow>
                              <IconButton type="button" aria-label="edit" color='primary' onClick={() => handleModal("UPDATE", row.id)}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{ width: '1.5rem' }}>
                                  <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                </svg>

                              </IconButton>
                            </Tooltip>
                            <Tooltip title={row.is_active ? 'Active' : 'Inactive'} arrow>
                              <IconButton
                                type="button"
                                aria-label="toggle-status"
                                color="primary"
                                onClick={() => handleStatusChange(row)}
                              >
                                {row.is_active ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </Tooltip>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    );
                  }) :
                !is_loading &&
                  stage_list.length === 0 ? (
                  <TableRow>
                    <TableCell align='center' colSpan={4}>
                      No Record Found
                    </TableCell>
                  </TableRow>) :
                  (<TableRow>
                    <TableCell align='center' colSpan={4}>
                      loading....
                    </TableCell>
                  </TableRow>
                  )
            }
          </TableBody>
          {stage_list.length > 0 && (
            <TableFooter>
              <TableRow>
                <TableCell colSpan={6} sx={{ padding: 0 }}>
                  <TablePagination
                    component="div"
                    count={total_stage_count}
                    page={page}
                    onPageChange={handlePageChange}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={[]}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableCell>
              </TableRow>
            </TableFooter>
          )}
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default StageTable